module.exports = {
      id: "user-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/symbols.e4df9320ab0fa712c143543fa64d490c.svg#user",
      toString: function () {
        return this.url;
      }
    }